import React from 'react'

interface LoadingSpinnerProps {
  size?: number
  color?: string
  centered?: boolean
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = 20, color = '#3274C8', centered = false }) => {
  const spinner = (
    <>
      <div
        style={{
          display: 'inline-block',
          width: `${size}px`,
          height: `${size}px`,
          border: `2px solid ${color}`,
          borderTopColor: 'transparent',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}
      />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </>
  )

  if (centered) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          width: '100%'
        }}
      >
        {spinner}
      </div>
    )
  }

  return spinner
}

export default LoadingSpinner
